'use client';

import { c as _c } from "react/compiler-runtime";
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { Icon } from '@/components/icon';
import { cn } from '@/lib/utils';
gsap.registerPlugin(ScrollToPlugin);
export function LearnMoreButton(t0) {
  const $ = _c(10);
  const {
    children,
    className
  } = t0;
  const handleScrollToNext = _temp;
  let t1;
  if ($[0] !== className) {
    t1 = cn("absolute bottom-4 left-1/2 z-20 -translate-x-1/2 cursor-pointer transition-opacity hover:opacity-80", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = children ? children : "Learn More";
  let t3;
  if ($[2] !== t2) {
    t3 = <span className="text-xs uppercase tracking-wider">{t2}</span>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Icon name="chevron" className="h-4 w-4 rotate-90" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <div className="flex flex-col items-center text-white/60">{t3}{t4}</div>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t1 || $[8] !== t5) {
    t6 = <button type="button" onClick={handleScrollToNext} className={t1}>{t5}</button>;
    $[7] = t1;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp() {
  window.scrollTo({
    top: window.innerHeight,
    behavior: "smooth"
  });
}